import type { PreventiveMaintenanceResource } from 'domains-work-order-authorization';
import { safeConvertToUUID } from 'uuid-encoding';

interface IdRef {
  id?: string | null;
}

interface UserRef {
  _id?: string | null;
}

export interface PmTaskRecord {
  id: string;
  groupBy?: IdRef | null;
  createdBy?: string | null;
  assignee?: UserRef | null;
  assigneeGroup?: (UserRef | null)[] | null;
}

export interface PmScheduleRecord {
  scheduleId?: string | null;
  extRefId?: IdRef | null;
  createdBy?: string | null;
  assignee?: IdRef | null;
  assigneeGroups?: (string | null)[] | null;
}

const toUuidOrEmpty = (id?: string | null): string =>
  safeConvertToUUID(id ?? '');

const toUuids = (ids: (string | null | undefined)[]): string[] =>
  ids.filter((id): id is string => Boolean(id)).map(safeConvertToUUID);

export const toPmTaskResource = (
  record: PmTaskRecord
): PreventiveMaintenanceResource => ({
  resourceId: safeConvertToUUID(record.id),
  channelId: toUuidOrEmpty(record.groupBy?.id),
  ownerId: toUuidOrEmpty(record.createdBy),
  assigneeId: record.assignee?._id
    ? safeConvertToUUID(record.assignee._id)
    : undefined,
  assigneeGroupIds: toUuids((record.assigneeGroup ?? []).map(g => g?._id)),
});

export const toPmScheduleResource = (
  record: PmScheduleRecord
): PreventiveMaintenanceResource => ({
  resourceId: toUuidOrEmpty(record.scheduleId),
  channelId: toUuidOrEmpty(record.extRefId?.id),
  ownerId: toUuidOrEmpty(record.createdBy),
  assigneeId: record.assignee?.id
    ? safeConvertToUUID(record.assignee.id)
    : undefined,
  assigneeGroupIds: toUuids(record.assigneeGroups ?? []),
});
